export default "__VITE_ASSET__BP_49CR___"